<div *ngIf="isLoading" class="loaderdata">
  <div class="spinner-border" role="status">
    <span class="sr-only">{{ "Form.Loading" | translate }}</span>
  </div>
</div>
<div *ngIf="!isLoading">
  <div class="mb-3 bg-transparent shadow-none" style="clear: both">
    <div
      class="card-header-tab bg-transparent d-flex flex-wrap justify-content-between border-bottom-0 ps-0 card-header summary"
    >
      <div
        class="card-header-title bg-transparent text-capitalize font-weight-bold text-left"
      >
        <i class="header-icon lnr-charts icon-gradient bg-happy-green"> </i>
        {{ "Form.SUMMARY" | translate }}
      </div>
      <div class="d-flex flex-row-reverse">
        <button
          type="button"
          *ngIf="buttonText"
          class="btn-shadow d-inline-flex align-items-center btn btn-primary"
          (click)="openProjectDetailView('')"
          style="float: right; margin-bottom: 10px; margin-left: 10px"
          placement="bottom"
          ngbTooltip="{{ 'Form.AddProject' | translate }}"
        >
          <i class="fa fa-plus pt-1 text-white font-size-lg"></i>
        </button>

        <div *ngIf="showUserManage">
          <button
            type=""
            *ngIf="buttonText"
            class="btn-shadow d-inline-flex align-items-center px-2 btn bg-warning"
            (click)="openUserManagement()"
            style="float: right; margin-bottom: 10px; margin-left: 10px"
            placement="bottom"
            ngbTooltip="{{ 'Form.ADDUser' | translate }}"
          >
            <i class="fa fa-user text-white font-size-lg"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="row mt-3" *ngIf="totalUsersCount > 1">
      <div class="col-sm-6 col-md-3 col-xl-3 summary_box">
        <div class="card user-box border-1 widget-chart text-left">
          <div
            class="icon-wrapper rounded-circle text-center mx-auto"
            style="border-radius: 50% !important"
          >
            <div class="icon-wrapper-bg opacity-10 bg-warning"></div>
            <i class="lnr-user text-white ms-3"></i>
          </div>
          <div class="widget-chart-content col-md-8">
            <div class="widget-subheading" style="display: flex">
              <div style="max-width: fit-content">
                {{ "Form.Users" | translate }}
              </div>
            </div>
            <div class="widget-numbers">{{ totalUsersCount }}</div>
          </div>
        </div>
        <div class="divider m-0 d-md-none d-sm-block"></div>
      </div>

      <div class="col-sm-6 col-md-3 col-xl-3 summary_box">
        <div class="card project-box border-1 widget-chart text-left">
          <div
            class="icon-wrapper rounded-circle text-center mx-auto"
            style="border-radius: 50% !important"
          >
            <div class="icon-wrapper-bg opacity-9 bg-danger"></div>
            <i class="lnr-laptop-phone text-white ms-3"></i>
          </div>
          <div class="widget-chart-content col-md-8">
            <div class="widget-subheading" style="display: flex">
              <div style="max-width: fit-content">
                {{ "Form.Projects" | translate }}
              </div>
            </div>
            <div class="widget-numbers">
              <span>{{ totalProjectsCount }}</span>
            </div>
          </div>
        </div>
        <div class="divider m-0 d-md-none d-sm-block"></div>
      </div>

      <div class="col-sm-6 col-md-3 col-xl-3 summary_box">
        <div class="card tooltip-box border-1 widget-chart text-left">
          <div
            class="icon-wrapper rounded-circle text-center mx-auto"
            style="border-radius: 50% !important"
          >
            <div class="icon-wrapper-bg opacity-9 bg-success"></div>
            <i class="lnr-graduation-hat text-white ms-3"></i>
          </div>
          <div class="widget-chart-content col-md-8">
            <div class="widget-subheading" style="display: flex">
              <div style="max-width: fit-content">
                {{ "Form.TOOLTIPS" | translate }}
              </div>
            </div>
            <div class="widget-numbers text-success">
              <span>{{ totalTooltipsCount }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-6 col-md-3 col-xl-3 summary_box">
        <div class="card workflow-box border-1 widget-chart text-left">
          <div
            class="icon-wrapper rounded-circle text-center mx-auto"
            style="border-radius: 50% !important"
          >
            <div class="icon-wrapper-bg opacity-9 bg-primary"></div>
            <i class="fa fa-road text-white ms-3"></i>
          </div>

          <div class="widget-chart-content col-md-8">
            <div class="widget-subheading" style="display: flex">
              <div style="max-width: fit-content">
                {{ "Form.WORKFLOW" | translate }}
              </div>
            </div>
            <div class="widget-numbers text-primary">
              <span>{{ totalWorkflowsCount }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div
      class="col-lg-4 col-md-12 col-sm-12 project-box"
      *ngFor="let pm of data"
    >
      <div class="card-hover-shadow-2x mb-3 card" id="project-card">
        <div
          class="card-header-tab mt-2 pt-2 card-header"
          style="padding: 0.2rem 0.5rem"
        >
          <div class="card-body mt-2 pt-1">
            <div class="card-title mt-2 mb-1 text-capitalize">
              {{ pm.name }}
            </div>

            <h6 class="card-subtitle mb-3 text-muted">
              Managed versions:
              {{ pm.version.length }}
            </h6>
          </div>
          <div
            class="btn-actions-pane-right text-capitalize actions-icon-btn"
            ngbDropdown
          >
            <button
              class="btn btn-icon bg-transparent btn-icon-only rounded-circle btn-link"
              style="border-radius: 50% !important"
              ngbDropdownToggle
            >
              <i
                class="fa fa-ellipsis-v"
                aria-hidden="true"
                style="font-size: 20px"
              ></i>
            </button>
            <div ngbDropdownMenu>
              <ul class="nav flex-column">
                <li class="nav-item">
                  <a
                    [routerLink]="['/page/auditlog', pm.id]"
                    [fragment]="'pendingPublish'"
                    class="nav-link text-center"
                    mat-menu-item
                    placement="left"
                    ngbTooltip="Change Log"
                    ><i
                      class="fa fa-history text-primary"
                      style="font-size: 20px !important; padding-left: 2px"
                      aria-hidden="true"
                    ></i
                  ></a>
                </li>
                <li class="nav-item">
                  <a
                    [routerLink]="['/page/project-detail', pm.id]"
                    class="nav-link text-center"
                    mat-menu-item
                    placement="left"
                    ngbTooltip="Edit"
                    ><i
                      class="fa fa-pencil-square-o text-primary"
                      style="font-size: 20px !important; padding-left: 2px"
                      aria-hidden="true"
                    ></i
                  ></a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link text-center"
                    mat-menu-item
                    (click)="openDeleteConfirmationDialog(pm)"
                    ngbTooltip="Delete"
                    placement="left"
                  >
                    <i
                      class="fa fa-trash-o text-danger"
                      style="font-size: 20px !important"
                      aria-hidden="true"
                    ></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div (click)="openScreenDetailView(pm.id)">
          <div class="">
            <div
              lass="vertical-time-simple vertical-without-time vertical-timeline vertical-timeline--animate vertical-timeline--one-column"
            >
              <div
                class="card no-shadow rm-border bg-transparent widget-chart text-left"
              >
                <div
                  class="icon-wrapper rounded-circle"
                  style="border-radius: 50% !important"
                >
                  <div class="icon-wrapper-bg opacity-10 bg-warning"></div>
                  <i class="lnr-laptop-phone text-white opacity-8"></i>
                </div>

                <div class="widget-chart-content">
                  <div
                    class="widget-subheading"
                    style="
                      display: -webkit-box;
                      -webkit-line-clamp: 3;
                      -webkit-box-orient: vertical;
                      overflow: hidden;
                    "
                  >
                    {{ pm.description }}
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="g-0 row">
                  <div class="col-md-12 col-lg-6">
                    <ul class="list-group list-group-flush">
                      <li class="bg-transparent list-group-item">
                        <div class="widget-content">
                          <div class="widget-content-outer">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left">
                                <div class="widget-heading">
                                  {{ "Form.SCREEN" | translate }}
                                </div>
                              </div>
                              <div class="widget-content-right">
                                <div class="widget-numbers text-warning">
                                  {{ pm.count.screens }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div class="col-md-12 col-lg-6">
                    <ul class="list-group list-group-flush">
                      <li class="bg-transparent list-group-item">
                        <div class="widget-content">
                          <div class="widget-content-outer">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left">
                                <div class="widget-heading">
                                  {{ "Form.LANGUAGE" | translate }}
                                </div>
                              </div>
                              <div class="widget-content-right">
                                <div class="widget-numbers text-danger">
                                  {{ pm.count.languages }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div class="col-md-12 col-lg-6">
                    <ul class="list-group list-group-flush">
                      <li class="bg-transparent list-group-item">
                        <div class="widget-content">
                          <div class="widget-content-outer">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left">
                                <div class="widget-heading">
                                  {{ "Form.TOOLTIPS" | translate }}
                                </div>
                              </div>
                              <div class="widget-content-right">
                                <div class="widget-numbers text-success">
                                  {{ pm.count.tooltips }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div class="col-md-12 col-lg-6">
                    <ul class="list-group list-group-flush">
                      <li class="bg-transparent list-group-item">
                        <div class="widget-content">
                          <div class="widget-content-outer">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left">
                                <div class="widget-heading">
                                  {{ "Form.WORKFLOW" | translate }}
                                </div>
                              </div>
                              <div class="widget-content-right">
                                <div class="widget-numbers text-primary">
                                  {{ pm.count.workflows }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div class="col-md-12 col-lg-6">
                    <ul class="list-group list-group-flush">
                      <li class="bg-transparent list-group-item">
                        <div class="widget-content">
                          <div class="widget-content-outer">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left">
                                <div class="widget-heading">
                                  {{ "Form.FAQ" | translate }}
                                </div>
                              </div>
                              <div class="widget-content-right">
                                <div class="widget-numbers text-orange">
                                  {{ pm.count.FAQs }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div class="col-md-12 col-lg-6">
                    <ul class="list-group list-group-flush">
                      <li class="bg-transparent list-group-item">
                        <div class="widget-content">
                          <div class="widget-content-outer">
                            <div class="widget-content-wrapper">
                              <div class="widget-content-left">
                                <div class="widget-heading">
                                  {{ "Form.USERGUIDE" | translate }}
                                </div>
                              </div>
                              <div class="widget-content-right">
                                <div class="widget-numbers text-orange">
                                  {{ pm.count.userGuides }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="d-block text-center card-footer py-1"
          style="
            padding-left: 10px !important;
            padding-right: 10px !important;
            display: flex !important;
            justify-content: center;
          "
        >
          <div *ngIf="pm.showTransButton">
            <button
              class="btn-shadow btn btn-primary btn-lg font-size-lg m-1"
              *ngIf="showUserManage || showTranslatorManage"
              style="
                padding-left: 15px !important;
                padding-right: 15px !important;
              "
              (click)="navigateToTranslation(pm.id, 'tooltip')"
            >
              {{ "Form.Translations" | translate }}
            </button>
          </div>
          <button
            id="manageButton"
            class="btn-shadow btn btn-primary btn-lg font-size-lg m-1"
            style="
              padding-left: 15px !important;
              padding-right: 15px !important;
            "
            (click)="openScreenDetailView(pm.id)"
          >
            {{ "Form.Manage" | translate }}
          </button>
          <button
            (click)="openUsageAnalytics(pm.id)"
            class="btn-shadow btn btn-primary btn-lg font-size-lg m-1"
            style="
              padding-left: 15px !important;
              padding-right: 15px !important;
            "
          >
            {{ "Form.UsageAnalytics" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    class="mb-3 p-5 card"
    style="clear: both"
    *ngIf="data?.length == 0 && isLoading"
  >
    <div class="col-sm-12">
      <div
        class="card no-shadow rm-border bg-transparent widget-chart font-size-lg"
      >
        <div class="no-project-card">
          {{ "Form.NoProject" | translate }} {{ isLoading }} {{ data.length }}
        </div>
      </div>
    </div>

    <div class="text-center d-block p-3">
      <button
        class="btn-pill btn-shadow btn-wide fsize-1 btn btn-primary btn-lg"
        style="justify-content: center"
        (click)="openProjectDetailView('')"
      >
        <span class="me-1">{{ "Form.AddProject" | translate }}</span>
      </button>
    </div>
  </div>
</div>
